module.exports = __webpack_public_path__ + "img/luckIcon.b8c546d3.png";